import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gongyingshangxixingpinggu",
  "use": "icon-gongyingshangxixingpinggu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-gongyingshangxixingpinggu\"><path d=\"M8.972 13.986H2.501a.499.499 0 01-.498-.5V2.499c0-.277.223-.5.498-.5h5.974v2.498c0 .55.446.999.995.999h2.49v2.997a.499.499 0 10.996 0V4.218a.497.497 0 00-.145-.353l-2.696-2.72A.499.499 0 009.762 1h-7.76a.998.998 0 00-.995.999v11.988c0 .551.446 1 .996 1h6.97a.499.499 0 000-1zm.996-9.49a.499.499 0 01-.498-.5V1.998l2.49 2.498H9.968zm-3.423 6.01H3.528a.499.499 0 000 .998h3.017a.499.499 0 000-.999zm2.957-2.998H3.528a.499.499 0 000 1h5.974a.499.499 0 000-1zM3.52 5.51h2.988a.499.499 0 000-.999H3.52a.499.499 0 000 1zm7.778 8.316a.5.5 0 01-.498-.523l.094-1.98-2.413.762a.498.498 0 11-.3-.952l3.095-.977a.499.499 0 01.648.5l-.092 1.968 2.488-.83a.5.5 0 01.317.948l-3.178 1.06a.58.58 0 01-.16.024z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/gongyingshangxixingpinggu.svg
// module id = 468
// module chunks = 4